export default class Header {
  constructor() {
    var _this             = this;
    _this.scrolled        = false;
    // LISTNERS
    $(window).scroll(function() {
      if ($(window).scrollTop() > 100 ) {
        _this.scrolled = true;
      }else {
        _this.scrolled = false;
      }
    })


    // TOGLLE MENU
    $(".hamburger").on("click", function(e) {
      $(this).toggleClass("is-active");
      $('.header__mobile-nav').toggleClass('header__mobile-nav--visible');
      $('body').toggleClass('noscroll');
    });

    // TOGGLE SUB MENU
    $('.navigation__item-title').click(function(event) {
      var parentHasSub = $(this).closest('.navigation__item').hasClass('navigation__item--has-sub');
      if (Modernizr.mq('screen and (max-width: 800px)') && parentHasSub) {
        event.preventDefault();
        $(this).closest('.navigation__item--has-sub').toggleClass('deployed');
        $(this).find('.icon--plus').toggleClass('icon--active');
      }
    });


    _this.initHelloBar();

    // LAST TO BIND DOM WHIT DATA
    // _this.initRivet();



  }

  initRivet(){
    // var _this       = this;
    // rivets.formatters.not     = function(bol){
    //   bol = !bol
    //   return bol
    // }
    //
    //
    // rivets.bind(document.querySelector('.header'),{
    //     header: _this
    //   }
    // );
  }

  initHelloBar(){
    var _this = this;

    _this.helloBar        = localStorage.getItem('kercambre-hello-bar') || true;

    if (_this.helloBar == "false" ) {
      _this.helloBar = false;
    }

    $('.header__hellobar-close').on('click', function(event) {
      event.preventDefault();
      _this.helloBar = false;
      localStorage.setItem('kercambre-hello-bar', false);
      $('.header__hellobar').hide();
      $('[hellobarcss]').remove();
    });

    if (_this.helloBar == false) {
      $('.header__hellobar').hide();
      $('[hellobarcss]').remove();
    }
  }

}

